const ceil = (value: number, to = 1) => {
  return Math.round(value / 1e3) * 1e3;
};

export default ceil;
